/* eslint-disable no-alert */
import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "recipient-form",
  class RecipientForm extends WYATTElement {
    constructor() {
      super();

      this.toggle = this.querySelector(
        `[name="properties[__shopify_send_gift_card_to_recipient]"]`
      );
      this.fieldsContainer = this.querySelector("[data-fields]");
      this.fields = Array.from(
        this.fieldsContainer.querySelectorAll("input, textarea")
      );
      this.emailField = this.fields.find((field) => field.type === "email");

      this.toggle.name = "gift-card-recipient-toggle";

      this.setTimezoneOffset();
      this.deactivateFields();

      this.toggle.addEventListener(
        "change",
        this.handleToggleChange.bind(this)
      );

      if (this.classList.contains("recipient-form--has-errors")) {
        this.activateFields();
      }
    }

    setTimezoneOffset() {
      const input = this.fields.find(
        (field) => field.name === "properties[__shopify_offset]"
      );

      input.value = new Date().getTimezoneOffset().toString();
    }

    handleToggleChange(event) {
      event.preventDefault();

      if (event.target.checked) {
        this.activateFields();
      } else {
        this.deactivateFields();
      }
    }

    activateFields() {
      this.fieldsContainer.setAttribute("active", true);
      this.fields.forEach((field) => {
        field.disabled = false;
      });
      this.emailField.required = true;
    }

    deactivateFields() {
      this.fieldsContainer.setAttribute("active", false);
      this.fields.forEach((field) => {
        field.disabled = true;
      });
      this.emailField.required = false;
    }
  }
);
